const Field = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  required = true,
  placeholder,
}) => (
  <label className="block">
    <span className="mb-2 block text-xs font-bold uppercase tracking-[.12em] text-ink/70">
      {label}
      {required && <span className="text-ocean"> *</span>}
    </span>
    {type === "textarea" ? (
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        rows="5"
        className="w-full resize-y rounded-2xl border border-ink/10 bg-white px-4 py-3 text-sm text-ink outline-none transition placeholder:text-slate/60 focus:border-ocean focus:ring-4 focus:ring-ocean/10"
      />
    ) : (
      <input
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        className="w-full rounded-2xl border border-ink/10 bg-white px-4 py-3 text-sm text-ink outline-none transition placeholder:text-slate/60 focus:border-ocean focus:ring-4 focus:ring-ocean/10"
      />
    )}
  </label>
);

export default Field;
